import { PagedApiResult } from "../models/utilities/paged-request";
import { BaseService } from "../services/_base-service";
import { ApiResponse, StatusCode } from "../utils/api";
import { SearchEventSummary } from "./models/activity/search-event-summary";
import { SupportActivitySearchFilters } from "./models/support-activity-search-filters";
import { SyncCommandResult } from "./models/sync/SyncCommandResult";
import { ApiEndpoints } from "../utils/app-constants";

export class SupportSvc extends BaseService {

    /**
     * Search Events based on the provided criteria 
     */
    public searchEvents = async (activityFilter : SupportActivitySearchFilters) : Promise<ApiResponse<PagedApiResult<SearchEventSummary>>> => {
        return await this.search(SearchEventSummary, activityFilter);
    }
    
    /**
     * Start the sync order process for the provided order. This resyncs the order
     * @param orderId The order ID of the order to resync
     * @returns True or false if the request succeeded or not
     */
    public syncOrder = async (orderId : string) : Promise<ApiResponse<SyncCommandResult>> => {

        const response = new ApiResponse<SyncCommandResult>();

        try {
            // Put all our print requests in a queue
            const result = await this._postWithError<SyncCommandResult>(
                ApiEndpoints.SYNC_ORDER_BY_ID.formattify(orderId),
                {}
            );

            const vmUpdate = new SyncCommandResult();
            vmUpdate.wasAttempted = true;
            vmUpdate.orderId = orderId;
            
            if (result.status !== StatusCode.Success) {
                vmUpdate.error = result.data as unknown as string;  
                console.log(result);
            }

            response.status = StatusCode.Success;
            response.data = vmUpdate;
        }
        catch (err) {
            response.status = this._handleError(err);
        }

        return response;
    }
    
}
